import React from "react";
import { Row, Col, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FormControl } from "react-bootstrap";
// import Background from '../../../assets/Images/Banner/Prodotti.jpg';
import Background from '../../../assets/Images/Banner/base.png';
export default function Qualita() {
    return (
        <>
            <div className="peopleSayBgColor spacing" style={{
                backgroundImage: "url(" + Background + ")",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="startToday spacing">
                    <div className="container" data-aos="zoom-in">
                        <div className="text-center" style={{ color: 'white' }}>
                            <h2 className="mb-4">Una qualità sempre garantita, 365 giorni l'anno</h2>
                        </div>
                        <div className="text-center" style={{ color: 'white' }}>
                            Sappiamo bene quanto sia importante offrirvi i prodotti più giusti in termini di qualità, segmentazione e funzionalità. Le tante realtà esistenti del settore food altamente e progressivamente più specializzate, ognuna con le proprie caratteristiche esigono attenzione particolare. Per questo abbiamo creato un'intera gamma di prodotti a marchio con oltre 400 referenze sia di trasformazione Ho.Re.Ca, sia di rivendita, in grado di coprire ogni specifica esigenza
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
